// extracted by mini-css-extract-plugin
export default {"userIcon":"user-button_userIcon__rmmGQ","signin":"user-button_signin__Rry2S"};